import Plyr from 'plyr';

// Every .jsPlyr element becomes a player: an uploaded <video>, or a YouTube/Vimeo
// <div data-plyr-provider data-plyr-embed-id>. Per-player options come from data-plyr-config.
const players = Plyr.setup('.jsPlyr', {
    youtube: { noCookie: true },
    vimeo: { dnt: true },
}) ?? [];

// Only one player plays at a time
players.forEach((player) => {
    player.on('play', () => {
        players.forEach((other) => other !== player && other.pause());
    });
});
